import { Transak } from "@transak/transak-sdk";
import { useStoreUserV2 } from "@/stores/storeUserV2";
import { isProd, transakApiKey } from "@/application/config";
import { pinia } from "~/main";
import { NotifType, useStoreApp } from "~/stores/storeApp";
import { IAuctionItem } from "~/common/interfaces/IMarketplace";
import { useWeb3AuthStore } from "@/stores/storeWeb3auth";

export const useTransak = () => {
  const storeApp = useStoreApp();

  const showOverlay = (input: { device: "desktop" | "mobile"; mode: "buy" | "sell" }) => {
    const storeUser = useStoreUserV2(pinia);
    const web3AuthStore = useWeb3AuthStore(pinia);
    const { device, mode } = input;
    let walletAddress = web3AuthStore.walletAddress;
    if (
      storeUser.smartWalletAddress &&
      web3AuthStore.smartWalletAddress?.toLowerCase() ===
        storeUser.smartWalletAddress?.toLowerCase()
    ) {
      walletAddress = web3AuthStore.smartWalletAddress;
    }

    const transak = new Transak({
      apiKey: transakApiKey,
      environment: isProd ? Transak.ENVIRONMENTS.PRODUCTION : Transak.ENVIRONMENTS.STAGING,
      productsAvailed: mode === "buy" ? "BUY" : "SELL",
      defaultCryptoCurrency: "USDC",
      defaultFiatCurrency: "EUR",
      defaultPaymentMethod: "credit_debit_card",
      defaultFiatAmount: 10,
      cryptoCurrencyList: ["POL", "USDC"],
      network: "POLYGON",
      walletAddress,
      email: storeUser.email,
      widgetHeight: device === "desktop" ? "625px" : "100%",
      widgetWidth: device === "desktop" ? "500px" : "100%",
    });

    transak.init();

    Transak.on(Transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, () => {
      console.log("Transak order successful");
      // storeApp.displayNotification(NotifType.FUNDS_DEPOSIT_SUCCESS, {} as IAuctionItem);

      storeUser.refreshBalance().catch(console.error);
      // transak.close();
    });

    Transak.on(Transak.EVENTS.TRANSAK_GET_USER_REQUEST, (e) => {
      console.log("Transak requested user info:", e);
    });

    Transak.on(Transak.EVENTS.TRANSAK_WALLET_REDIRECTION, (e) => {
      console.log("Transak wallet redirection:", e);
    });

    Transak.on(Transak.EVENTS.TRANSAK_ORDER_FAILED, () => {
      storeApp.displayNotification(NotifType.FUNDS_DEPOSIT_FAILED, {} as IAuctionItem);
      transak.close();
    });

    Transak.on(Transak.EVENTS.TRANSAK_WIDGET_CLOSE, (data) => {
      transak.close();
    });

    Transak.on(Transak.EVENTS.TRANSAK_WIDGET_CLOSE_REQUEST, (data) => {
      transak.close();
    });
  };

  return {
    showOverlay,
  };
};
